import { render, staticRenderFns } from "./AddOrUpdateRmcForm.vue?vue&type=template&id=51c454b3"
import script from "./AddOrUpdateRmcForm.vue?vue&type=script&lang=js"
export * from "./AddOrUpdateRmcForm.vue?vue&type=script&lang=js"
import style0 from "./AddOrUpdateRmcForm.vue?vue&type=style&index=0&id=51c454b3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports